// extracted by mini-css-extract-plugin
module.exports = {"headerBasic":"header-basic_headerBasic__InXj_","logoContainer":"header-basic_logoContainer__vkeKM"};